// src/App.js
import React, { useState, createContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Layout from './components/layout/Layout';

// Core pages
import Home from './pages/Home';
import About from './pages/About';
import News from './pages/News';
import Projects from './pages/Projects';
import Research from './pages/Research';
import PrototypePage from './pages/PrototypePage';
import RoadmapPage from './pages/Roadmap';
import ContactPage from './pages/Contact';
import NeuromorphicSimulator from './pages/NeuromorphicSimulator';
import Cornerstone from './pages/Cornerstone';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AIEthicsPolicy from './pages/AIEthicsPolicy';
import TermsOfService from './pages/TermsOfService';
import UnityLodge from './pages/UnityLodge';
import Security from './pages/Security';
import UnityScholarsProgram from './pages/UnityScholarsProgram';

export const ThemeContext = createContext();
export const AlienContext = createContext();
export const VanguardContext = createContext();

function App() {
  const [darkMode, setDarkMode] = useState(false);

  const [vanguardState, setVanguardState] = useState({
    inPresentation: false,
    currentSlide: 0,
    inQAMode: false
  });

  const toggleAlien = () => {};

  return (
    <ThemeContext.Provider value={{ darkMode, setDarkMode }}>
      <AlienContext.Provider value={{ toggleAlien }}>
        <VanguardContext.Provider value={{ vanguardState, setVanguardState }}>
          <Router>
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/about" element={<Layout><About /></Layout>} />
              <Route path="/news" element={<Layout><News /></Layout>} />
              <Route path="/projects" element={<Layout><Projects /></Layout>} />
              <Route path="/research" element={<Layout><Research /></Layout>} />
              <Route path="/documentation" element={<Layout><Research /></Layout>} />
              <Route path="/cornerstone" element={<Layout><Cornerstone /></Layout>} />
              <Route path="/security" element={<Layout><Security /></Layout>} />
              <Route path="/prototype" element={<Layout><PrototypePage /></Layout>} />
              <Route path="/roadmap" element={<Layout><RoadmapPage /></Layout>} />
              <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
              <Route path="/neuromorphic" element={<Layout><NeuromorphicSimulator /></Layout>} />
              <Route path="/privacy" element={<Layout><PrivacyPolicy /></Layout>} />
              <Route path="/ai-ethics" element={<Layout><AIEthicsPolicy /></Layout>} />
              <Route path="/terms" element={<Layout><TermsOfService /></Layout>} />
              <Route path="/unity" element={<Layout><UnityLodge /></Layout>} />
              <Route path="/Δ" element={<Layout><UnityLodge /></Layout>} />
              <Route path="/delta" element={<Layout><UnityLodge /></Layout>} />
              
              {/* Unity Scholars Program */}
              <Route path="/unity-scholars" element={<Layout><UnityScholarsProgram /></Layout>} />

              <Route path="*" element={
                <Layout>
                  <div className="container mx-auto px-4 py-16 text-center">
                    <h1 className="text-3xl font-bold text-white mb-4">Page Not Found</h1>
                    <p className="text-gray-300">The page you are looking for does not exist.</p>
                  </div>
                </Layout>
              } />
            </Routes>
          </Router>
        </VanguardContext.Provider>
      </AlienContext.Provider>
    </ThemeContext.Provider>
  );
}

export default App;